import React, { useEffect, useState, useContext } from "react";
import "./AuctionDetails.css";
import UserPro from "../../../../Assets/Images/Shakib/pro.jpg";
import BGImg from "../../../../Assets/Images/Souvenir/fundo-floral-preto-png-2.png";
import Bid from "../../../../Assets/Images/Souvenir/Icons/bid.png";
import Confirm from "../../../../Assets/Images/Souvenir/Icons/auction.png";
import BiddingHistory from "../Content/RightSideAuction/BiddingHistory/BiddingHistory";
import SuperstarCard from "../Content/RightSideAuction/SuperstarCard/SuperstarCard";
// import ApplyImg from "../../../../Assets/Images/Souvenir/Illustration/Gift.svg";
import InstructionModal from "./InstructionModal";
import { Markup } from "interweave";
import axios from "axios";
import ReactImageMagnify from "react-image-magnify";
import { serverInfo, socketContext } from "../../../../App";
import moment from "moment";
import RemainingTimeAuction from "./RightSideAuction/RemainingTimeAuction/RemainingTimeAuction";
import { LocationContext } from "../../../../CustomHelper/Helper";
import { Link, useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";

const AuctionDetails = ({ data }) => {
  const { imageCdnUrl } = useContext(serverInfo);
  let { product_id } = useParams();

  const history = useHistory();

  const { paymentCount, paymentCountWithSymbol } = useContext(LocationContext);

  const socketData = useContext(socketContext);

  const [modalShow, setModalShow] = React.useState(false);
  const [priceAlert, setPriceAlert] = React.useState(false);
  const [priceMinAlert, setPriceMinAlert] = React.useState(false);

  const [passwordAlert, setPasswordAlert] = React.useState(false);
  const [liveBidding, setLiveBidding] = useState([]);
  const [bidHistory, setBidHistory] = useState([]);
  const [currentMaxBid, setCurrentMaxBid] = useState(0);
  const [auctionInfo, setAuctionInfo] = useState();
  const [auctionApply, setApply] = useState();
  const [auctionId, setAuctionId] = useState();
  const [instruction, setInstruction] = useState([]);
  const [showMore, setShowMore] = useState(false);

  const { slectedCurrency, payStatus } = useContext(LocationContext);
  const [countryBaseCost, setCountryBaseCost] = useState(false);


  const openModal = (id) => {
    setModalShow(true);
    setAuctionId(id);
  };

  const dateTime = new Date();
  const startTime = new Date(auctionInfo?.bid_from);
  const endTime = new Date(auctionInfo?.bid_to);

  const resultTime = new Date(auctionInfo?.result_date);

  const bidingHistory = () => {
    axios.get(`/api/user/liveBidding/history/${data.id}`).then((res) => {
      if (res.data.status === 200) {
        setBidHistory(res.data.bidHistory);
      }
    });
  };

  const topBidder = () => {
    axios.get(`/api/user/liveBidding/auction/${data.id}`).then((res) => {
      if (res.data.status === 200) {
        setLiveBidding(res.data.bidding);
        if(res?.data?.bidding.length>0) {
          setCurrentMaxBid(res?.data?.bidding[0]?.amount)
        }
      }
    });
  };

  useEffect(() => {
    socketData.emit("joinBiddingRoom", { room: data.id });
    socketData.emit("sendLiveBidding", data.id);

    socketData.on("getLiveBidding", (data) => {
      topBidder();
    });

    axios.get(`/api/auction-product/${data.id}`).then((res) => {
      if (res.data.status === 200) {
        setAuctionInfo(res.data.auctionInfo);
        setInstruction(res.data.instruction);
      }
    });

    axios.get(`/api/user/auctionApply/auction/${data.id}`).then((res) => {
      if (res.data.status === 200) {
        setApply(res.data.auctionApply);
      }
    });

    bidingHistory();
    topBidder();
  }, []);

  // const handelCuntrybasePrice = (fee) => {
  //   return (Number(fee) * Number(slectedCurrency?.currency_value)).toFixed(0);
  // };

  // useEffect(() => {
  //   setCountryBaseCost(
  //     (
  //       Number(data?.base_price) * Number(slectedCurrency?.currency_value)
  //     ).toFixed(0)
  //   );
  // }, [data, slectedCurrency]);

  const [auctionInput, setAuctionInput] = useState({
    auction_id: data.id,
    amount: "",
    password: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setAuctionInput((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const auctionSubmit = (e) => {
    e.preventDefault();
    setPriceAlert(false);
    setPriceMinAlert(false);
    let userNewBid =  Number(auctionInput?.amount) /  Number(slectedCurrency?.currency_value);

    if (Number(auctionInput.amount) > Number(paymentCount(data?.base_price))) {
      if (Number(userNewBid) > Number(currentMaxBid+0.001)) {
      const fdata = {
        auction_id: auctionInput.auction_id,
        amount:
          Number(auctionInput?.amount) /
          Number(slectedCurrency?.currency_value),
        password: auctionInput.password,
      };

      axios.get("/sanctum/csrf-cookie").then((response) => {
        axios.post(`/api/user/bidding/auction/product`, fdata).then((res) => {
          if (res.data.status === 200) {
            swal("Thanks", res.data.message, "success");
            socketData.emit("joinBiddingRoom", { room: data.id });
            socketData.emit("sendLiveBidding", data.id);
            socketData.on("getLiveBidding", (sdata) => {
              // setLiveBidding(sdata);
            });
            setPriceAlert(false);
            setPriceMinAlert(false);
            setPasswordAlert(false);
            bidingHistory();
            topBidder();
          }
          if (res.data.status === 201) {
            setPasswordAlert(true);
          }
          if (res.data.status === 202) {
            setCurrentMaxBid(res?.data?.maxBid)
            setPriceAlert(false);
            setPriceMinAlert(true);
            setPasswordAlert(false);
            bidingHistory();
            topBidder();
          }
        });
      });
    } else {
      setPriceMinAlert(true);
    }
    } else {
      setPriceAlert(true);
    }
  };

  return (
    <>
      <div className="col-md-7">
        <h3 className="fw-bolder text-white mt-4">{data.title}</h3>

        <p className="text-white PText">
          {showMore ? (
            <Markup content={data?.details} />
          ) : (
            <Markup content={data?.details.substring(0, 200)} />
          )}
          <button
            className="btn text-white PText"
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? "Show less" : "Show more"}
          </button>
        </p>

        <h4 className="text-warning">
          Base Price: <small>{paymentCountWithSymbol(data?.base_price)}</small>
        </h4>

        <div className="ReactCr7 bg-dark p-4 mb-3 ">
          <ReactImageMagnify
            {...{
              smallImage: {
                alt: "Image Not Found",
                isFluidWidth: true,
                src: imageCdnUrl + data?.product_image,
              },
              largeImage: {
                src: imageCdnUrl + data?.product_image,
                width: 1800,
                height: 1800,
              },
            }}
          />
        </div>

        <div className="bg-dark mb-3 ">
          <div className="row mx-3 CR7Scroll ">
            <p className="text-light mt-3 fw-bold">Live Bidding</p>

            {liveBidding?.map((bid) => (
              <>
                <div className="containerSa col-md-4 col-lg-4 mb-3">
                  <div className="carousel w-100 ">
                    <img src={BGImg} className="Cr7img" alt={BGImg} />
                    <img
                      src={imageCdnUrl + bid.user?.image}
                      alt={UserPro}
                      className="Cr7Pro "
                    />
                    <div className="Cr7View"></div>
                    <h1 className="btn Cr7s py-1 text-warning fw-bold">
                      {paymentCountWithSymbol(bid.amount)}
                    </h1>
                    <h5 className="btn Cr7ss py-1 text-light ">
                      {bid.user?.first_name} {bid.user?.last_name}
                    </h5>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
        {dateTime?.getTime() < endTime?.getTime() ? (
          <>
            <form onSubmit={auctionSubmit}>
              <div className="bg-dark mb-3">
                <div className="row mx-3 justify-content-between ">
                  <p className="text-light mt-3 fw-bold">Bid Now</p>

                  <div className=" col-md-6 mb-3 ">
                    <div>
                      <input
                        autoComplete={false}
                        type="number"
                        onChange={handleInput}
                        value={auctionInput.amount}
                        name="amount"
                        className="p-3 mb-3 w-100 inputBgSA"
                        placeholder="Enter amount"
                        min="1"
                      />
                    </div>

                    <div>
                      {passwordAlert ? (
                        <span className="text-warning">
                          Password is Invalid!
                        </span>
                      ) : (
                        ""
                      )}

                      <input
                        type="password"
                        onChange={handleInput}
                        value={auctionInput.password}
                        name="password"
                        className="p-3 mb-3 w-100 inputBgSA"
                        placeholder="Enter Password"
                      />
                    </div>
                  </div>

                  <div className=" col-md-4 col-lg-4 mb-3 ">
                    {priceAlert ? (
                      <div className="d-flex justify-content-end">
                        <button className="btn Acquire fw-bold px-4 py-2 mb-3">
                          <i className="fas fa-id-card-alt"> </i> &nbsp;
                          Bidding Price should be greater than {" "}
                          {paymentCountWithSymbol(data?.base_price  < currentMaxBid ? currentMaxBid : data?.base_price)}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}

                    {priceMinAlert ? (
                        <div className="d-flex justify-content-end">
                          <button className="btn Acquire fw-bold px-4 py-2 mb-3">
                            <i className="fas fa-id-card-alt"> </i> &nbsp; Bidding Price should be greater than {" "}
                            {paymentCountWithSymbol(currentMaxBid  )}
                          </button>
                        </div>
                    ) : (
                        ""
                    )}
                    <img src={Bid} alt={Bid} className="img-fluid BibImg" />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                {dateTime?.getTime() < startTime?.getTime() ? (
                  <button
                    className="btn ConfirmS fw-bold px-4 py-2 mb-3"
                    disabled
                  >
                    {" "}
                    <img
                      src={Confirm}
                      className="ConfirmCR7"
                      alt={Confirm}
                    />{" "}
                    &nbsp;Bid Now
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn ConfirmS fw-bold px-4 py-2 mb-3"
                  >
                    {" "}
                    <img
                      src={Confirm}
                      className="ConfirmCR7"
                      alt={Confirm}
                    />{" "}
                    &nbsp;Bid Now
                  </button>
                )}
              </div>
            </form>
          </>
        ) : (
          <div className="notify-img bg-dark text-center">
            <img
              // src={ApplyImg}
              alt="this is Apply msg"
              className="img-fluid ApplyImg p-5"
            />

            <div className="content-info  py-1">
              <h4 className="text-light text-center">
                Result Will Be Published-
                {moment(auctionInfo?.result_date).format("LL")}
              </h4>
              {resultTime?.getTime() < new Date().getTime() &&
              auctionApply?.applied_status == 0 ? (
                <>
                  <h3 className="text-warning text-center">Please Wait</h3>
                  <h3 className="text-warning text-center warning">
                    And Complete Further Process
                  </h3>
                </>
              ) : null}
            </div>
          </div>
        )}
        <div className="d-flex justify-content-end mt-2">
          {resultTime?.getTime() < new Date().getTime() ? (
            <button
              className="btn btn-black Acquire fw-bold px-4  mb-3"
              onClick={() => {
                history.push(`/auction-winner/${product_id}`);
              }}
            >
              Show Result
            </button>
          ) : (
            new Date().getTime() > endTime?.getTime() &&
            resultTime?.getTime() > new Date().getTime() && (
              <button
                disabled={
                  auctionApply?.notify_status > 0 &&
                  auctionApply?.applied_status == 0
                    ? false
                    : true
                }
                className="btn Acquire fw-bold px-4 py-2 mb-3"
                onClick={() => openModal(auctionInfo.id)}
              >
                <i className="fas fa-id-card-alt text-warning"> </i> &nbsp;
                {auctionApply?.applied_status > 0
                  ? "You are already applied"
                  : "Acquire application"}
              </button>
            )
          )}

          <InstructionModal
            data={instruction}
            show={modalShow}
            id={auctionId}
            onHide={() => setModalShow(false)}
          />
        </div>
      </div>

      <div className="col-md-4">
        <RemainingTimeAuction AuctionData={data} />
        <SuperstarCard AuctionData={data} />
        <BiddingHistory AuctionData={bidHistory} />
      </div>
    </>
  );
};

export default AuctionDetails;
